import { Controller } from "@hotwired/stimulus";

class ProductCardGallery extends Controller {
  static values = {
    slidesSmall: Number,
    slidesMedium: Number,
    slidesLarge: Number,
  };

  static targets = ["swiper", "pagination", "nextBtn", "prevBtn"];

  connect() {
    super.connect();
    if (this.swiper) {
      return;
    }

    const swiperConfig = {
      spaceBetween: 10,
      slidesPerView: "auto",
      loop: true,
      breakpoints: {
        0: { slidesPerView: this.slidesSmallValue },
        640: { slidesPerView: this.slidesMediumValue },
        1024: { slidesPerView: this.slidesLargeValue },
        1280: { slidesPerView: this.slidesLargeValue },
      },
    };

    if (this.hasNextBtnTarget) {
      swiperConfig.navigation = {
        nextEl: this.nextBtnTarget,
        prevEl: this.prevBtnTarget,
      };
      swiperConfig.pagination = {
        el: this.paginationTarget,
        bulletClass:
          "swiper-pagination-bullet tw:border tw:border-blue-700 tw:bg-transparent tw:opacity-100",
        bulletActiveClass: "tw:bg-blue-700!",
        clickable: true,
      };
    }

    this.swiper = new Swiper(this.swiperTarget, swiperConfig);
    setTimeout(() => {
      if (this.swiper) {
        this.swiper.update();
        this.swiper.navigation.update();
      }
    }, 100);
  }

  disconnect() {
    if (this.swiper) {
      this.swiper.destroy();
      this.swiper = null;
    }
  }
}

Stimulus.register("productCardGallery", ProductCardGallery);
